module.exports = __webpack_public_path__ + "static/media/PDF_60.c20f7527.pdf";